export default function poll(fn: () => Promise<any>, check: (data: any) => boolean, interval: number) {
  const executePoll = async (resolve: any, reject: any) => {
    const result = await fn();

    if (check(result)) {
      return resolve(result);
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };
  return new Promise(executePoll);
};